import { useEffect } from 'react';
import { useAddQuery, useQuery } from './useQuery';

export const getQueryParamsTableState = () => {
  const search = new URLSearchParams(window.location.search);

  const data = {
    page: search?.get('page') ? Number(search.get('page')) - 1 : 0,
    rowsPerPage: search?.get('rowsPerPage') ? Number(search.get('rowsPerPage')) : 0,
    searchText: search?.get('searchText') || '',
  };

  return data;
};

const usePreserveTableState = ({ pageData, activeFilters }) => {
  const { page, rowsPerPage, searchText } = pageData;

  const search = useQuery();
  //eslint-disable-next-line
  const [_, setMultipleQuery] = useAddQuery();

  useEffect(() => {
    const preservedQueryParams = {
      ...search,
      page: page + 1,
      rowsPerPage,
      searchText,
    };

    setMultipleQuery(preservedQueryParams);

    //eslint-disable-next-line
  }, [page, rowsPerPage, activeFilters, searchText, search]);
};

export default usePreserveTableState;
